import * as types from './actionTypes';

export function getProfileSuccess(profile) {
  return {
    type: types.GET_PROFILE_SUCCESS,
    profile
  };
}
